import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    imgHover: {
        height: 40,
        transition: "all 0.5s ease",
        "&:hover": {
            filter: "brightness(1.2)",
        },
    },
}));

export const Logo = () => {
    const classes = useStyles();

    return (
        <a href="https://ecliptica.xyz">
            <img
                src="/logo.svg" // <-- replace with your logo file path
                alt="ËCLIPTICÄ Logo"
                className={classes.imgHover}
            />
        </a>
    );
};